const PRICE_FORMATS = {
    cz: { locale: 'cs-CZ', currency: 'CZK', fractionDigits: 0 },
    sk: { locale: 'sk-SK', currency: 'EUR', fractionDigits: 2 },
    de: { locale: 'de-DE', currency: 'EUR', fractionDigits: 2 },
    at: { locale: 'de-AT', currency: 'EUR', fractionDigits: 2 },
    hu: { locale: 'hu-HU', currency: 'HUF', fractionDigits: 0 }
};

/**
 * Formats a price by the country of the current top-level domain (CZ, SK, DE, AT, HU).
 * CZ uses the Alza notation "24 990,-", other countries the local currency format.
 * Unknown domains (e.g. 127.0.0.1) fall back to CZ.
 * @param {number} value - Price
 * @returns {string}
 */
export function formatPrice(value) {
    const tld = window.location.hostname.split('.').pop().toLowerCase();
    const country = PRICE_FORMATS[tld] ? tld : 'cz';
    const { locale, currency, fractionDigits } = PRICE_FORMATS[country];
    const options = {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
    };

    if (country !== 'cz') Object.assign(options, { style: 'currency', currency });

    const price = new Intl.NumberFormat(locale, options).format(value).replace(/[\u00a0\u202f]/g, ' ');
    return country === 'cz' ? `${price},-` : price;
}
